import { IIcon } from '../../model/icon';

export const check: IIcon = {
  id: `CHECK`,
  svg: ` <path fill="#00AB8D" d="M17.5 5.83l-10 10-4.58-4.58 1.17-1.18 3.41 3.4 8.82-8.81 1.18 1.17z" />`
};
